import React, { FC } from 'react';
import { Theme, Svg } from 'styled';
import { Color } from 'styled/theme/colors';

type Props = {
  className?: string;
  color: Color;
};

const PinterestIconReverse: FC<Props> = ({
  className = '',
  color = 'white',
}) => (
  <Svg
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    className={className}
    fill="transparent"
  >
    <desc>Pinterest Icon.</desc>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.6147 26.9271C11.7661 26.8371 10.9423 26.6653 10.1512 26.4192C10.6797 25.5557 11.4725 24.1406 11.766 23.0113C11.9242 22.4029 12.5757 19.9215 12.5757 19.9215C12.9998 20.7297 14.2382 21.415 15.5564 21.415C19.476 21.415 22.3015 17.8089 22.3015 13.3286C22.3015 9.03416 18.7968 5.81988 14.2873 5.81988C8.6777 5.81988 5.6985 9.58728 5.6985 13.6881C5.6985 15.5933 6.71256 17.9687 8.33507 18.7246C8.58244 18.8383 8.71457 18.7876 8.77142 18.5495C8.78884 18.4767 8.83522 18.2886 8.89077 18.0632C8.97245 17.7319 9.07397 17.3202 9.13249 17.076C9.16322 16.9439 9.14786 16.8317 9.04184 16.7026C8.50408 16.0512 8.07541 14.8527 8.07541 13.7357C8.07541 10.8687 10.2464 8.09384 13.9447 8.09384C17.139 8.09384 19.3745 10.2695 19.3745 13.3823C19.3745 16.8993 17.5984 19.3361 15.2876 19.3361C14.0123 19.3361 13.0566 18.2821 13.3624 16.9869C13.495 16.4285 13.6724 15.8542 13.8449 15.2958C14.1498 14.3086 14.4394 13.3711 14.4394 12.6587C14.4394 11.66 13.9032 10.8272 12.7954 10.8272C11.4894 10.8272 10.4431 12.1762 10.4431 13.9846C10.4431 15.1354 10.8318 15.9144 10.8318 15.9144C10.8318 15.9144 9.54273 21.3612 9.30765 22.3752C9.04645 23.4999 9.14785 25.0779 9.26155 26.1058C4.57407 24.2692 1.21071 19.7916 1.00953 14.5025C1.25595 20.9857 6.25001 26.2529 12.6147 26.9271ZM14 28C21.732 28 28 21.732 28 14C28 6.26801 21.732 0 14 0C6.26801 0 0 6.26801 0 14C0 21.732 6.26801 28 14 28Z"
      fill={Theme.colors[color]}
    />
  </Svg>
);

export default PinterestIconReverse;
